import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AdUnitService } from '../../../../../../../services/adunit.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AdUnit } from '../../../../../../../models/adunit';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import {
    SelectService,
    SelectedOption
} from '../../../../../../../_services/select.service';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-adunit',
    templateUrl: './update-adunit.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateAdUnitComponent extends BaseComponent implements OnInit {
    returnUrl: any;
    adunit: AdUnit = new AdUnit();
    sizes: any[] = [];
    siteId: string;
    pageId: string;
    publisherName: string;
    multiSelectSize: any;

    constructor(
        private adunitService: AdUnitService,
        private selectService: SelectService,
        private dataService: DataService,
        private router: Router,
        route: ActivatedRoute
    ) {
        super();
        this.adunit.id = route.snapshot.params.id;
        this.siteId = route.snapshot.queryParams.siteId;
        this.pageId = route.snapshot.queryParams.pageId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.breadcrumb = route.snapshot.queryParams.pageName;
        route.snapshot.parent.data.queryParams = {
            siteId: this.siteId,
            pageId: this.pageId
        };
        route.snapshot.parent.data.url = '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.data.breadcrumb =
            route.snapshot.queryParams.siteName;
        route.snapshot.parent.parent.data.queryParams = { siteId: this.siteId };
        route.snapshot.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams.tab = PublisherDetailTab.Inventory;
            route.snapshot.parent.parent.data.queryParams.tab =
                PublisherDetailTab.Inventory;
            route.snapshot.parent.data.queryParams.name = this.publisherName;
            route.snapshot.parent.parent.data.queryParams.name = this.publisherName;
            route.snapshot.parent.parent.parent.data.breadcrumb = this.publisherName;
        }
    }

    ngOnInit() {
        this.getAdUnit();
    }

    getAdUnit() {
        Helpers.setLoading(true);
        this.adunitService.find(this.adunit.id).subscribe(res => {
            this.adunit = res.data;
            this.initSizeMultiSelect();
            Helpers.setLoading(false);
        });
    }

    initSizeMultiSelect() {
        var selectedData: SelectedOption[] = [];

        this.selectService.init({
            url: '/sizes/list',
            controlId: 'sizes',
            displayProperty: 'title',
            selectedOptions: selectedData
        });
    }

    navigate() {
        let queryParams = { siteId: this.siteId, pageId: this.pageId };
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                title: customRules.requiredText,
                sizes: {
                    required: true
                }
            }
        });
    }

    updateAdUnit() {
        var _self = this;
        Helpers.setLoading(true);
        this.adunitService.update(this.adunit).subscribe(res => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/adunit/update-adunit/update-adunit.component.ts